import api from "./api";
import {
  parseListPayload,
  extractTeacherListStats,
  extractTeacherCategoryCounts,
} from "utils/paginationStats";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** UI gender labels → API values (partial match on server). */
export function genderFilterToApi(value) {
  const v = String(value ?? "").trim();
  if (v === "Homme") return "M";
  if (v === "Femme") return "F";
  return v;
}

export const TEACHER_LIST_FILTER_KEYS = [
  "search",
  "preName",
  "name",
  "regNumber",
  "email",
  "degree",
  "status",
  "phone",
  "whatsapp",
  "gender",
  "identificationNumber",
  "recruiter",
  "recruiterId",
];

export const EMPTY_TEACHER_FILTERS = {
  search: "",
  preName: "",
  name: "",
  regNumber: "",
  email: "",
  degree: "",
  status: "",
  phone: "",
  whatsapp: "",
  gender: "",
  identificationNumber: "",
  recruiter: "",
  recruiterId: "",
  /** "" = all, "true" = teachers, "false" = staff */
  isTeacher: "",
};

/** Build query params for GET /Teacher/list */
export function buildTeacherListParams({ pageNumber = 1, pageSize = 10, category = 1, filters = {} } = {}) {
  const params = {
    pageNumber,
    pageSize,
    category,
  };

  const isTeacherRaw = filters.isTeacher;
  if (isTeacherRaw === true || isTeacherRaw === "true") params.isTeacher = true;
  else if (isTeacherRaw === false || isTeacherRaw === "false") params.isTeacher = false;

  TEACHER_LIST_FILTER_KEYS.forEach((key) => {
    const raw = filters[key];
    if (key === "recruiterId") {
      if (raw !== "" && raw != null) params.recruiterId = Number(raw);
      return;
    }
    const value = String(raw ?? "").trim();
    if (!value) return;
    params[key] = key === "gender" ? genderFilterToApi(value) : value;
  });

  return params;
}

export function parseTeacherListResponse(data) {
  const rows = parseListPayload(data);
  const stats = extractTeacherListStats(rows, data);
  const categoryCounts = extractTeacherCategoryCounts(data);
  return {
    rows,
    stats,
    categoryCounts,
    activeFilters: data?.stats?.filters ?? data?.stats?.Filters ?? null,
    activeCategory: Number(data?.stats?.category ?? data?.stats?.Category ?? 0) || null,
  };
}

export async function fetchTeacherList({ pageNumber, pageSize, category, filters }) {
  const params = buildTeacherListParams({ pageNumber, pageSize, category, filters });
  const res = await api.get("/Teacher/list", { params, headers: authHeaders() });
  return parseTeacherListResponse(res.data);
}

export async function fetchTeacherListForExport({ category, filters, pageSize = 5000 }) {
  return fetchTeacherList({ pageNumber: 1, pageSize, category, filters });
}
